<template>
  <div class="saved-search-form">
    <button
      v-if="!isNamingSearch"
      class="saved-search-form__start-btn btn-filter"
      :disabled="!hasFilters"
      @click.prevent="startSaveSearch"
    >
      Зберегти пошук
    </button>

    <div v-else class="saved-search-form__row">
      <div class="saved-search-form__input">
        <input
          v-model="searchName"
          type="text"
          placeholder="Введіть назву пошуку"
          @keyup.enter="confirmSaveSearch"
          @blur="cancelSaveSearch"
        />
      </div>

      <button
        class="saved-search-form__confirm-btn btn-filter"
        @mousedown="preventCancel"
        @click.prevent.stop="confirmSaveSearch"
      >
        Підтвердити
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { getActiveFiltersForSaving } from '@/utils/saved-filters';

export default {
  name: 'SavedSearchForm',
  props: {
    hasFilters: Boolean,
    savedSearches: Array
  },
  data() {
    return {
      isNamingSearch: false,
      searchName: '',
      preventCancelBlur: false
    };
  },
  methods: {
    ...mapActions(['addSavedSearch']),
    startSaveSearch() {
      this.isNamingSearch = true;
      this.$nextTick(() => {
        const input = this.$el.querySelector('.saved-search-form__input input');
        if (input) input.focus();
      });
    },
    async confirmSaveSearch() {
      const name = this.searchName.trim();
      if (!name) return;

      const exists = this.savedSearches.some(
        (s) => s.label.trim().toLowerCase() === name.toLowerCase()
      );

      if (exists) {
        this.$notify({
          group: 'app',
          duration: 6000,
          type: 'error',
          text: 'Пошук з такою назвою вже існує'
        });
        return;
      }

      const filters = getActiveFiltersForSaving(this.$store.state);
      if (Object.keys(filters).length === 0) return;

      const payload = {
        label: name,
        filters,
        business_type: this.$store.state.filter_header?.businessType || '',
        type: this.$store.state.filter_header?.buildingType || ''
      };

      await this.addSavedSearch(payload);

      this.isNamingSearch = false;
      this.searchName = '';
    },
    cancelSaveSearch() {
      if (this.preventCancelBlur) {
        this.preventCancelBlur = false;
        return;
      }
      this.isNamingSearch = false;
      this.searchName = '';
    },
    preventCancel() {
      this.preventCancelBlur = true;
    },
    getCleanedFilterForm(key) {
      const form = this.$store.state[key].form;
      if (!form) return {};

      return Object.entries(form)
        .filter(([field, value]) => {
          if (key === 'filter_address' && field === 'city') return false;
          return this.isValidFilterValue(value);
        })
        .reduce((obj, [field, value]) => {
          obj[field] = value;
          return obj;
        }, {});
    },
    isValidFilterValue(value) {
      return (
        (Array.isArray(value) && value.length > 0) ||
        (typeof value === 'string' && value.trim() !== '') ||
        typeof value === 'number'
      );
    }
  }
};
</script>

<style lang="sass">
.saved-search-form
  &__start-btn
    width: 100%

  &__row
    display: flex
    gap: 0.5rem

  &__input
    flex: 1 1 auto

    input
      display: block
      border: none
      border-radius: 1.375rem
      width: 100%
      min-height: 1.375rem
      padding: 0.125rem 0.5rem
      background-color: var(--color-white)
      font-size: 0.75rem
      font-weight: 600
      line-height: 1
</style>
